import { Typography } from "antd";
import { useTranslation } from "react-i18next";

const { Text } = Typography;

export const AppSlogan = () => {
  const { t } = useTranslation();

  return <Text className="app-slogan">{t("global:slogan")}</Text>;
};
